module.exports = __webpack_public_path__ + "static/media/LedPay_logo.d0cc559e.png";